import React from 'react';

const Beyond: React.FC = () => (
  <section id="beyond" className="beyond-section py-24">
    <div className="section-transition" aria-hidden="true"><span>The person behind the systems</span></div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="beyond-layout">
        <div>
          <span className="section-eyebrow">Beyond building / 06</span>
          <h2 className="text-4xl md:text-6xl font-bold text-white mt-3">There is life outside the terminal.</h2>
        </div>
        <div className="beyond-copy">
          <p>I enjoy the energy and strategy of cricket and tennis, conversations that challenge an assumption, classic web series, and the surprisingly serious pursuit of a very good lime soda.</p>
          <p>I value curiosity, humility and people who care deeply about their craft. The best work, in my experience, grows from genuine interest—not performance.</p>
          <div className="beyond-notes"><span>Cricket & tennis</span><span>Open source</span><span>Classic stories</span><span>Lime soda</span></div>
        </div>
      </div>
    </div>
  </section>
);

export default Beyond;
